import { api } from './services'

export const getResearchCampaign = (researchCampaignId) =>
  api
    .get(`/researchcampaigns/${researchCampaignId}`)
    .then((res) => res.data.result)
